import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Image.module.scss.js';

var Image = function Image(_ref) {
  var url = _ref.url,
    isPortrait = _ref.isPortrait,
    alt = _ref.alt,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    onError = _ref.onError;
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: classNames(styles.image, isPortrait ? styles.portrait : styles.landscape, className),
    src: url,
    id: dataTestId,
    onError: onError
  });
};
Image.propTypes = {
  url: PropTypes.string.isRequired,
  isPortrait: PropTypes.bool,
  alt: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onError: PropTypes.func
};
Image.defaultProps = {
  isPortrait: false,
  alt: 'img',
  className: '',
  dataTestId: null,
  onError: function onError() {}
};

export { Image as default };
